import { useSelector } from '@shared/store';

export function useCurrentBusinessId(): number | undefined {
  return useSelector(state => state.appState.currentBusinessId);
}
